import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import {
    MetadataTranslation,
    MetadataTranslationId,
    OrganisationId,
    ShPaginationService
} from '@stylehaven/components';
import { HttpService } from '../http/http.service';

@Injectable({ providedIn: 'root' })
export class MetadataTranslationsService {
    private readonly metadataTranslationsEndpoint: string = `v2/metadata-translations`;

    // Injectors
    private readonly http: HttpService = inject(HttpService);
    private readonly paginationService: ShPaginationService = inject(ShPaginationService);

    public getMetadataTranslation(id: MetadataTranslationId): Observable<MetadataTranslation> {
        const request = `${this.metadataTranslationsEndpoint}/${id}`;

        return this.http.get<MetadataTranslation>(request);
    }

    public getExportLocationsByOrganisation(organisationId: OrganisationId): Observable<MetadataTranslation[]> {
        const request = `${this.metadataTranslationsEndpoint}/`;
        const params: HttpParams = new HttpParams().set('organisationId', organisationId);

        return this.paginationService.getAll<MetadataTranslation>(request, params);
    }
}
